<div class="notification-container" [class.unread]="!notification.isRead">
  <div class="header">
    <p class="title">{{ notification.title }}</p>
    <button
      class="close-btn"
      (click)="clearNotification(notification.isServer)"
    >
      ✕
    </button>
  </div>
  <p class="description">{{ notification.description }}</p>
  <div class="footer">
    @if (notification.pdfUrl) {
      <a class="link" [href]="notification.pdfUrl" target="_blank">View PDF</a>
    }
    @if (notification.type) {
      <p class="type">{{ notification.type }}</p>
    }
    @if (notification.status === "Completed" && notification.queueId) {
      <button class="link" (click)="getReportLink(notification.queueId)">
        Download Report
      </button>
    }
  </div>
</div>
